import React from "react";
import { Divider, Space } from "antd";
import LeftTop from "./leftTop";
import LeftBottom from "./leftBottom";

const LeftNavigationContainer = () => {
	return <LeftBottom />;
};

export default LeftNavigationContainer;
